import config from "../_config";


function getImageURL(image) {
    return image ? image.includes("http") || image.includes("base64") ? image
        : config.baseUrl + image : "https://www.tibs.org.tw/images/default.jpg";
}
export default getImageURL;